import { tokens } from 'ComponentLibrary/style-dictionary/output'
import { Box, styled } from '@mui/material'

type CounterDotProps = {
    number: number
    variant?: 'primary' | 'secondary'
    overwrite?: string
}

export const CounterDot = ({ variant = 'primary', number, overwrite }: CounterDotProps) => (
    <StyledCounterDot $variant={variant} $mainColor={COUNTER_DOT_COLORS[number % 10]}>
        {overwrite || number}
    </StyledCounterDot>
)

const COUNTER_DOT_COLORS: string[] = [
    tokens.ColorGraphSequentialTenMedium,
    tokens.ColorGraphSequentialOneMedium,
    tokens.ColorGraphSequentialTwoMedium,
    tokens.ColorGraphSequentialThreeMedium,
    tokens.ColorGraphSequentialFourMedium,
    tokens.ColorGraphSequentialFiveMedium,
    tokens.ColorGraphSequentialSixMedium,
    tokens.ColorGraphSequentialSevenMedium,
    tokens.ColorGraphSequentialEightMedium,
    tokens.ColorGraphSequentialNineMedium,
]

const StyledCounterDot = styled(Box, {
    shouldForwardProp: (prop: string) => prop[0] !== '$',
})(({ $mainColor, $variant }: { $mainColor: string; $variant: 'primary' | 'secondary' }) => ({
    backgroundColor: $variant === 'primary' ? $mainColor : tokens.ColorSurfaceDefault,
    color: $variant === 'primary' ? tokens.ColorTextInverse : $mainColor,
    border: $variant === 'primary' ? 'none' : `${tokens.SizingBorderS} solid ${$mainColor}`,
    borderRadius: tokens.SizingCornerRound,
    width: '20px',
    height: '20px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    ...tokens.Headline4,
}))
